module.exports = __webpack_public_path__ + "media/customizations/caldwellcommunities/logo-new-e5aa0bfef6db9f85252131380f02cf52.png";